import { render, staticRenderFns } from "./page-about-us.vue?vue&type=template&id=5202fe4f"
import script from "./page-about-us.js?vue&type=script&lang=js&external"
export * from "./page-about-us.js?vue&type=script&lang=js&external"
import style0 from "./page-about-us.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports